import React from 'react';

const AppleLogo = () => (
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20" fillRule="evenodd" clipRule="evenodd" strokeMiterlimit="1.414">
      <path
         fill="#000"
         fillRule="nonzero"
         d="M8.112 4.59c.54 0 1.544-.743 2.85-.743 2.25 0 3.135 1.6 3.135 1.6s-1.73.885-1.73 3.032c0 2.42 2.155 3.25 2.155 3.25s-1.507 4.24-3.542 4.24c-.935 0-1.662-.63-2.647-.63-1.004 0-2 .65-2.648.65-1.86 0-4.207-4.03-4.207-7.26 0-3.19 1.988-4.85 3.852-4.85 1.21 0 2.152.69 2.782.69zm.563-3.198C9.725.007 11.188 0 11.188 0s.217 1.303-.827 2.558c-1.11 1.34-2.38 1.12-2.38 1.12s-.24-1.054.7-2.286z "
      />
   </svg>
);

export default AppleLogo;
